export default __webpack_public_path__ + "static/media/delete_icon.df981649.svg";